import styled from 'styled-components';
import { gutter } from '../../styles/mixins';
import type { PolymorphicComponentProps } from '../../utils/types';
import type { ButtonProps } from './button';
import { ButtonHost } from './button';

export const ArrowButtonHost = styled(ButtonHost)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${gutter(3)};
  width: ${gutter(3)};
  padding: 3px 7px;

  border-color: transparent;
`;

export const ArrowButton = <C extends React.ElementType = 'button'>(
  props: PolymorphicComponentProps<C, ButtonProps>
) => {
  const { as, children, fullWidth, ...rest } = props;
  return (
    <ArrowButtonHost as={as as any} $fullWidth={fullWidth} {...rest}>
      {children}
    </ArrowButtonHost>
  );
};
